import React, { useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import logo from "../../../assets/images/logo.png";
import { NavLink } from "react-router-dom";
function HeaderComponent() {

  const [downloadAppModalShow, setdownloadAppModalShow] = React.useState(false);
  
  const [navbarCollapse, setNavbarCollapse] = useState(false);
  const collapseMenu = () => {
      setNavbarCollapse(!navbarCollapse);
  };
  return (
    <>
      <header >
        <Navbar collapseOnSelect expand="lg" className="">
          <Container>
            <NavLink to="/" className="navbar-brand">
              <img src={logo} alt="image" />
            </NavLink>
            <Navbar.Toggle aria-controls="responsive-navbar-nav"  onClick={collapseMenu} />
            <Navbar.Collapse className="d-none" id="responsive-navbar-nav">
              <Nav className="ms-auto align-items-lg-center">
                <NavLink className="nav-link" to="/">
                  Home
                </NavLink>
                <NavLink className="nav-link" to="about-us">
                  About us
                </NavLink>
                <NavLink className="nav-link" to="jobs">
                  Jobs
                </NavLink>
                {(window.location.origin === "http://localhost:3000" ||
                  window.location.origin === "https://prorider.in" ||
                  window.location.origin === "https://www.prorider.in") && (
                  <NavLink className="nav-link" to="database">
                    Database
                  </NavLink>
                )}
                <NavLink className="nav-link" to="blogs">
                  Blogs
                </NavLink>
                <NavLink className="nav-link download_app" to="/coming-soon">
                  Download app
                </NavLink>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>

      <div className={navbarCollapse ? 'sideMenu opensideMenu' : ' sideMenu hideSideMenu'}>
        <Navbar>
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="flex-column">
                <NavLink  onClick={collapseMenu} className="nav-link" to="/">
                  Home
                </NavLink>
                <NavLink  onClick={collapseMenu} className="nav-link" to="about-us">
                  About us
                </NavLink>
                <NavLink  onClick={collapseMenu} className="nav-link" to="jobs">
                  Jobs
                </NavLink>
                {(window.location.origin === "http://localhost:3000" ||
                  window.location.origin === "https://prorider.in" ||
                  window.location.origin === "https://www.prorider.in") && (
                  <NavLink  onClick={collapseMenu} className="nav-link" to="database">
                    Database
                  </NavLink>
                )}
                <NavLink  onClick={collapseMenu} className="nav-link" to="blogs">
                  Blogs
                </NavLink>
                <NavLink  onClick={collapseMenu} className="nav-link download_app" to="/coming-soon">
                  Download app
                </NavLink>
              </Nav>
            </Navbar.Collapse>
        </Navbar>
      </div>
    </>
  );
}

export default HeaderComponent;
